import { put, select, takeLatest, takeEvery, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import {
    actions,
    socialCampaignsFetched,
    socialCampaignsByObjectiveFetched,
    socialCalloutsByObjectiveFetched,
    socialAdSetsFetched,
    socialAdSetsByObjectiveFetched,
    socialAdsFetched,
    socialAdsByObjectiveFetched,
    socialDataByObjectiveFetched,
    socialActionsFetched,
    socialActionsByObjectiveFetched,
    socialUniqueMeasuresFetched,
    socialUniqueMeasuresByObjectiveFetched,
    socialDemographicsFetched,
    socialDemographicsByObjectiveFetched
} from './duck';

import {
    socialCampaignsEndpoint,
    socialCampaignsByObjectiveEndpoint,
    socialCalloutsByObjectiveEndpoint,
    socialAdSetsEndpoint,
    socialAdSetsByObjectiveEndpoint,
    socialAdsEndpoint,
    socialAdsByObjectiveEndpoint,
    socialDataByObjectiveEndpoint,
    socialActionsEndpoint,
    socialActionsByObjectiveEndpoint,
    socialUniqueMeasuresEndpoint,
    socialUniqueMeasuresByObjectiveEndpoint,
    socialDemographicsEndpoint,
    socialDemographicsByObjectiveEndpoint,
} from './selectors';

export function* fetchSocialCampaigns(api, action) {
    let transactionName = [
        'fetchSocialCampaigns'
    ];
    let endpointSelector = socialCampaignsEndpoint;
    let successAction = socialCampaignsFetched;

    if (action.payload.objective) {
        transactionName.push('byObjective', action.payload.objective);
        endpointSelector = socialCampaignsByObjectiveEndpoint;
        successAction = socialCampaignsByObjectiveFetched;
    }

    transactionName = transactionName.join('-');

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(endpointSelector, action.payload)
            }
        );

        if (action.payload.objective) {
            result.data.objective = action.payload.objective;
        }

        yield put(successAction(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialAdSets(api, action) {
    let transactionName = [
        'fetchSocialAdSets'
    ];
    let endpointSelector = socialAdSetsEndpoint;
    let successAction = socialAdSetsFetched;

    if (action.payload.objective) {
        transactionName.push('byObjective', action.payload.objective);
        endpointSelector = socialAdSetsByObjectiveEndpoint;
        successAction = socialAdSetsByObjectiveFetched;
    }

    transactionName = transactionName.join('-');

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(endpointSelector, action.payload)
            }
        );

        if (action.payload.objective) {
            result.data.objective = action.payload.objective;
        }

        yield put(successAction(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialAds(api, action) {
    let transactionName = [
        'fetchSocialAds'
    ];
    let endpointSelector = socialAdsEndpoint;
    let successAction = socialAdsFetched;

    if (action.payload.objective) {
        transactionName.push('byObjective', action.payload.objective);
        endpointSelector = socialAdsByObjectiveEndpoint;
        successAction = socialAdsByObjectiveFetched;
    }

    transactionName = transactionName.join('-');

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(endpointSelector, action.payload)
            }
        );

        if (action.payload.objective) {
            result.data.objective = action.payload.objective;
        }

        yield put(successAction(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialCalloutsByObjective(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(socialCalloutsByObjectiveEndpoint, action.payload)
            }
        );

        result.data.objective = action.payload.objective;

        yield put(socialCalloutsByObjectiveFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialDataByObjective(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(socialDataByObjectiveEndpoint, action.payload)
            }
        );

        result.data.objective = action.payload.objective;

        yield put(socialDataByObjectiveFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialActions(api, action) {
    let transactionName = [
        'fetchSocialActions'
    ];
    let endpointSelector = socialActionsEndpoint;
    let successAction = socialActionsFetched;

    if (action.payload.objective) {
        transactionName.push('byObjective', action.payload.objective);
        endpointSelector = socialActionsByObjectiveEndpoint;
        successAction = socialActionsByObjectiveFetched;
    }

    transactionName = transactionName.join('-');

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(endpointSelector, action.payload)
            }
        );

        if (action.payload.objective) {
            result.data.objective = action.payload.objective;
        }

        yield put(successAction(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialDemographics(api, action) {
    let transactionName = [
        'fetchSocialDemographics'
    ];
    let endpointSelector = socialDemographicsEndpoint;
    let successAction = socialDemographicsFetched;

    if (action.payload.objective) {
        transactionName.push('byObjective', action.payload.objective);
        endpointSelector = socialDemographicsByObjectiveEndpoint;
        successAction = socialDemographicsByObjectiveFetched;
    }

    transactionName = transactionName.join('-');

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(endpointSelector, action.payload)
            }
        );

        if (action.payload.objective) {
            result.data.objective = action.payload.objective;
        }

        yield put(successAction(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSocialUniqueMeasures(api, action) {
    let transactionName = [
        'fetchSocialUniqueMeasures'
    ];
    let endpointSelector = socialUniqueMeasuresEndpoint;
    let successAction = socialUniqueMeasuresFetched;

    if (action.payload.objective) {
        transactionName.push('byObjective', action.payload.objective);
        endpointSelector = socialUniqueMeasuresByObjectiveEndpoint;
        successAction = socialUniqueMeasuresByObjectiveFetched;
    }

    transactionName = transactionName.join('-');

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(endpointSelector, action.payload)
            }
        );

        if (action.payload.objective) {
            result.data.objective = action.payload.objective;
        }

        if (action.payload.grain) {
            result.data.grain = action.payload.grain;
        }

        yield put(successAction(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* socialSaga({ api }) {
    yield all([
        takeEvery(actions.FETCH_ACTIONS_BY_OBJECTIVE, fetchSocialActions, api),
        takeEvery(actions.FETCH_DEMOGRAPHICS_BY_OBJECTIVE, fetchSocialDemographics, api),
        takeEvery(actions.FETCH_ADS_BY_OBJECTIVE, fetchSocialAds, api),
        takeEvery(actions.FETCH_ADSETS_BY_OBJECTIVE, fetchSocialAdSets, api),
        takeEvery(actions.FETCH_CALLOUTS_BY_OBJECTIVE, fetchSocialCalloutsByObjective, api),
        takeEvery(actions.FETCH_CAMPS_BY_OBJECTIVE, fetchSocialCampaigns, api),
        takeEvery(actions.FETCH_DATA_BY_OBJECTIVE, fetchSocialDataByObjective, api),
        takeEvery(actions.FETCH_UNIQUE_MEASURES_BY_OBJECTIVE, fetchSocialUniqueMeasures, api),
        takeLatest(actions.FETCH_ACTIONS, fetchSocialActions, api),
        takeLatest(actions.FETCH_DEMOGRAPHICS, fetchSocialDemographics, api),
        takeLatest(actions.FETCH_ADSETS, fetchSocialAdSets, api),
        takeLatest(actions.FETCH_CAMPAIGNS, fetchSocialCampaigns, api),
        takeLatest(actions.FETCH_UNIQUE_MEASURES, fetchSocialUniqueMeasures, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/social/saga.js